import * as RadixTooltip from "@radix-ui/react-tooltip";
import React from "react";
import Tooltip from "../../components/Tooltip";

export interface ITooltipProps {
    tooltip?: React.ReactNode;
    tooltipSide?: RadixTooltip.TooltipContentProps["side"];
}

export default function withTooltip<TProps extends JSX.IntrinsicAttributes>(
    WrappedComponent: React.ComponentType<TProps>
) {
    return React.forwardRef<unknown, TProps & ITooltipProps>(({ tooltip, tooltipSide = "top", ...props }, ref) => {
        const wrappedJsx = <WrappedComponent {...(props as unknown as TProps)} ref={ref} />;

        if (!tooltip) {
            return wrappedJsx;
        }

        return (
            <Tooltip tooltip={tooltip} tooltipSide={tooltipSide}>
                {wrappedJsx}
            </Tooltip>
        );
    });
}
